import {
  Box,
  Image,
  Text,
  Stack,
  Container,
} from "@chakra-ui/react";

import Navbar from "./Navbar";
import { useAuth } from './AuthContext';

import HeroImage from "./images/stamps.png";

const ApiDocumentation = () => {
  const { user } = useAuth();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      {!user ? (
        <Container maxW="container.md" py={20}>
          <Box
            bg="white"
            p={6}
            borderRadius="md"
            boxShadow="md"
            textAlign="center"
          >
            <Text fontSize="md">
              You must be logged in to view this content.
            </Text>
          </Box>
        </Container>
      ) : (
        <Container maxW="container.xl" py={8}>
          <Stack spacing={6} align="left" textAlign="center">
            {/* Workflow Section */}
            <Box
              bg="rgba(255, 255, 255, 0.9)"
              p={4}
              borderRadius="md"
              boxShadow="md"
              border="1px solid #3182ce"
            >
              <Text fontSize="lg" fontWeight="bold" mb={2}>Workflow</Text>
              <br />
              {[
                { name: "Temporal", url: "http://217.154.50.62:8088/", desc: "View Temporal workflow instance." },
              ].map(({ name, url, desc }) => (
                <Box key={name} mb={4}>
                  <Text
                    as="a"
                    href={url}
                    color="blue.600"
                    fontSize="lg"
                    target="_blank"
                    rel="noopener noreferrer"
                    display="block"
                    _hover={{ textDecoration: "underline" }}
                  >
                    {name}
                  </Text>
                  <Text fontSize="sm" fontStyle="italic">{desc}</Text>
                </Box>
              ))}
            </Box>

            {/* API Swaggers Section */}
            <Box
              bg="rgba(255, 255, 255, 0.9)"
              p={4}
              borderRadius="md"
              boxShadow="md"
              border="1px solid #3182ce"
            >
              <Text fontSize="lg" fontWeight="bold" mb={2}>API Swaggers</Text>
              <br />
              {[
                { name: "AuthAPI", url: "https://auth.poc.mrc.ai/swagger", desc: "Manages Users and Authentication." },
                { name: "ClockAPI", url: "https://clock.poc.mrc.ai/swagger", desc: "Handles real-time and simulated time controls..." },
                { name: "CodexAPI", url: "https://codex.mrc.ai/swagger", desc: "Provides platform level master data management services..." },
                { name: "CodifyAPI", url: "https://codify.poc.mrc.ai/swagger", desc: "Provides codify services..." },
                { name: "CuratorAPI", url: "https://curator.poc.mrc.ai/swagger", desc: "Provides source data curation services..." },
                { name: "DirectoryAPI", url: "https://directory.poc.mrc.ai/swagger", desc: "Manages parties..." },
                { name: "DocumentRenderAPI", url: "https://documentrender.poc.mrc.ai/swagger", desc: "Manages document rendering services..." },
                { name: "DocumentsAPI", url: "https://documents.poc.mrc.ai/swagger", desc: "Manages document definitions and documents..." },
                { name: "LedgersAPI", url: "https://ledgers.poc.mrc.ai/swagger", desc: "Smart Ledger services..." },
                { name: "MrcaiAPI", url: "https://poc.mrc.ai/swagger", desc: "Central application services..." },
                { name: "PannerAPI", url: "https://panner.poc.mrc.ai/swagger", desc: "Provides Panner services..." },
                { name: "PermissionsAPI", url: "https://permissions.poc.mrc.ai/swagger", desc: "Provides Permissions services..." },
                { name: "PipesAPI", url: "https://pipes.mrc.ai/swagger", desc: "Background pipework services..." },
                { name: "PlacingAPI", url: "https://placing.poc.mrc.ai/swagger", desc: "Provides GRLC Placing services..." },
                { name: "RegistersAPI", url: "https://registers.poc.mrc.ai/swagger", desc: "Manages registers..." },
                { name: "WorkflowAPI", url: "https://workflow.poc.mrc.ai/swagger", desc: "Manages workflow processes..." },
                { name: "XolAPI", url: "https://poc.mrc.ai/xol/swagger", desc: "Manages Excess of Loss contracts..." },
              ].map(({ name, url, desc }) => (
                <Box key={name} mb={4}>
                  <Text
                    as="a"
                    href={url}
                    color="blue.600"
                    fontSize="lg"
                    target="_blank"
                    rel="noopener noreferrer"
                    display="block"
                    _hover={{ textDecoration: "underline" }}
                  >
                    {name}
                  </Text>
                  <Text fontSize="sm" fontStyle="italic">{desc}</Text>
                </Box>
              ))}
            </Box>
          </Stack>
        </Container>
      )}
    </Box>
  );
};

export default ApiDocumentation;
